import React from 'react';
import { FieldType } from 'enums/FieldTypeEnums';
import { FieldsRowProps } from 'shared/components/FieldsRow';
import styles from './commodityDistribution.module.scss';
import { IndexBadge } from 'shared/components/IndexBadge';
import { allowOnlyNumbersUptoN } from 'shared/utils/convertFormData';
import { stage5Fields } from 'constants/FarmboxConstants/stage5.constants';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import { UseFieldArrayRemove, useFormContext } from 'react-hook-form';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import clsx from 'clsx';

interface CommodityDistributionLayoutDataProps {
  index: number;
  remove: UseFieldArrayRemove;
  toggleLocationModal?: (index: number) => void;
  routesLength?: number;
  fetchData: (params?: { 'input-field': string }) => void;
  isDisabled?: boolean;
}
const {
  TOTAL_QUANTITY_PLACEHOLDER,
  ROUTES,
  CHECK_BOX_LABEL,
  TOTAL_QUANTITY_NAME,
  QUANTITY_LABEL,
  END_MARKET_LABEL,
  LOCATION_FIELD,
  QUANTITY,
  IS_TRANSPORT_BY_AIR,
} = stage5Fields;

export const GetFormData = (
  props: CommodityDistributionLayoutDataProps
): FieldsRowProps => {
  const { watch, trigger } = useFormContext();
  const {
    index,
    remove,
    toggleLocationModal,
    routesLength,
    isDisabled,
    fetchData,
  } = props;
  const removeHandler = () => {
    remove(index);
    handleQuantityChanges();
  };
  const handleOpenLocationModal = () => toggleLocationModal?.(index);

  const handleQuantityChanges = () => {
    const fieldsToTrigger = watch(`${ROUTES}`).map(
      (_: unknown, i: number) => `${ROUTES}.${i}.${QUANTITY}`
    );

    trigger(fieldsToTrigger);
  };
  return {
    data: [
      {
        type: FieldType.ELEMENT,
        additionalElement: (
          <div className={styles.numberContainer}>
            <IndexBadge index={index} />
          </div>
        ),
        span: 1,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${ROUTES}.${index}.${LOCATION_FIELD}`,
          label: END_MARKET_LABEL,
          placeholderstring: END_MARKET_LABEL,
          onClick: handleOpenLocationModal,
          suffix: <MapSearch />,
          readOnly: true,
          onFocus: () =>
            fetchData({
              'input-field': 'farmbox_ag_commodity_end_market_location',
            }),
          disabled: isDisabled,
        },
        span: 7,
      },

      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${ROUTES}.${index}.${QUANTITY}`,
          label: QUANTITY_LABEL,
          placeholderstring: QUANTITY_LABEL,
          onKeyDown: allowOnlyNumbersUptoN(4),
          isNullable: true,
          onFocus: () =>
            fetchData({
              'input-field':
                'farmbox_ag_commodity_quantity_of_crop_sent_to_this_location',
            }),
          disabled: isDisabled,
          onChange: () => handleQuantityChanges(),
        },
        span: 7,
      },
      {
        type: FieldType.CHECKBOX,
        fieldProps: {
          name: `${ROUTES}.${index}.${IS_TRANSPORT_BY_AIR}`,
          label: CHECK_BOX_LABEL,
          disabled: isDisabled,
        },
        span: 6,
      },
      {
        type: FieldType.ELEMENT,
        additionalElement: routesLength && routesLength > 1 && (
          <div
            className={clsx(styles.deleteContainer, {
              [styles.hideAction]: isDisabled,
            })}
            onClick={removeHandler}>
            <DeleteButton />
          </div>
        ),
        span: 1,
      },
    ],
  };
};

export const getTotalQuantityFormData = (): FieldsRowProps => {
  return {
    data: [
      {
        type: FieldType.ELEMENT,
        span: 1,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: TOTAL_QUANTITY_NAME,
          label: TOTAL_QUANTITY_PLACEHOLDER,
          placeholderstring: TOTAL_QUANTITY_PLACEHOLDER,
          disabled: true,
        },
        span: 7,
      },
    ],
  };
};
